import dashboardSlice from "./slice";

export const { loadingDashboard, dashboardError, dashboardSuccess, reset } =
  dashboardSlice.actions;

export default dashboardSlice.reducer;
